import {CLEAR_MAIN_BUSINESS_ACTION, SELECT_MAIN_BUSINESS_ACTION} from '../../../actionType';

export default function (state = {}, action) {
    switch (action.type) {
        case SELECT_MAIN_BUSINESS_ACTION:
            return {
                ...state,
                commodityCode:action.id,
                commodityName:action.commodityCategoryName,
                key:action.id,
            };
        case CLEAR_MAIN_BUSINESS_ACTION:
            return {};
        default:
            return state;
    }
}
